import { Tooltip } from 'framework/ui/mui-builder';
import { CustomBadge, FieldBadgeProps } from 'framework/ui/ui-builder';

const MARKED_FOR_ARCHIVAL_TOOLTIP =
  'This position slot is flagged for archival. It has not been archived yet and can still be updated.';

const PositionSlotMarkedForDeletionBadge = (props: FieldBadgeProps) => {
  const badgeProps = {
    text: 'Marked for archival',
    color: 'warning' as const,
    ...props,
  };

  return (
    <Tooltip title={MARKED_FOR_ARCHIVAL_TOOLTIP}>
      <span style={{ display: 'inline-flex', alignItems: 'center', verticalAlign: 'middle' }}>
        <CustomBadge {...badgeProps} />
      </span>
    </Tooltip>
  );
};

export default PositionSlotMarkedForDeletionBadge;
